import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { Head, Nav, Footer } from '@components';
import { GlobalStyle, theme } from '@styles';

const Spotlight = styled.div`
  pointer-events: none;
  position: fixed;
  inset: 0;
  z-index: 30;
  transition: opacity 0.3s;
  background: radial-gradient(
    600px at ${({ x }) => x}px ${({ y }) => y}px,
    var(--spotlight),
    transparent 80%
  );
`;

const Layout = ({ children, location }) => {
  const isHome = location.pathname === '/';
  const [pos, setPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    document.body.classList.toggle('inner-page', !isHome);
    return () => document.body.classList.remove('inner-page');
  }, [isHome]);

  useEffect(() => {
    const onMove = e => setPos({ x: e.clientX, y: e.clientY });
    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, []);

  const handleExternalLinks = () => {
    const allLinks = Array.from(document.querySelectorAll('a'));
    if (allLinks.length > 0) {
      allLinks.forEach(link => {
        if (link.host !== window.location.host) {
          link.setAttribute('rel', 'noopener noreferrer');
          link.setAttribute('target', '_blank');
        }
      });
    }
  };

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.substring(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView();
          el.focus();
        }
      }, 0);
    }

    handleExternalLinks();
  }, []);

  return (
    <>
      <Head />

      <div id="root">
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <Spotlight x={pos.x} y={pos.y} />

          <a className="skip-to-content" href="#content">
            Skip to Content
          </a>

          {!isHome && <Nav isHome={false} />}

          <div id="content">
            {children}
            {!isHome && <Footer />}
          </div>
        </ThemeProvider>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
};

export default Layout;
